import type { FC, ReactNode } from 'react'
import type { PlaybackStatus } from '@/lib/audio/engine'

import { cn } from '@/lib/utils'

interface PlayGlyphProps {
    status: PlaybackStatus
    className?: string
}

// Play triangle, pause bars and a loading tick, drawn in CSS so no icon set is needed.
const PlayGlyph: FC<PlayGlyphProps> = ({ status, className }): ReactNode => {
    if (status === 'playing') {
        return (
            <span aria-hidden='true' className={cn('flex h-[14px] items-stretch gap-[4px]', className)}>
                <span className='w-[4px] bg-current' />
                <span className='w-[4px] bg-current' />
            </span>
        )
    }

    if (status === 'loading') {
        return (
            <span aria-hidden='true' className={cn('block size-[14px] animate-spin border-[2.5px] border-current border-r-transparent', className)} />
        )
    }

    return (
        <span
            aria-hidden='true'
            className={cn('ml-[3px] block h-0 w-0 border-y-[8px] border-l-[13px] border-y-transparent border-l-current', className)}
        />
    )
}

export default PlayGlyph
